import React, { Fragment, useEffect, useState } from 'react';
import { Typography } from '@progress/kendo-react-common';
import { Loader, Skeleton } from '@progress/kendo-react-indicators';
import 'jsoneditor-react/es/editor.min.css';
import Dialog from '../../components/Dialog';
import { useSapFlow, useSapFlowParamsUpdate, useSapFlowProcessNode } from '../../hooks/data_delivery';
import Logs from '../SapFlowDetails/Logs';

interface Props {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  sapflowId: string;
  processNodeId: string;
}

let shown = false;

const SapFlowStatusHistory: React.FC<Props> = (props: Props) => {
  const sapFlowParamsUpdateMutation = useSapFlowParamsUpdate();
  const sapFlowProcessNodeQuery = useSapFlowProcessNode(shown ? props.sapflowId : null, props.processNodeId);
  useEffect(() => {
    shown = true;
  }, [props.show]);

  const parametersAvailable = true;
  const loading = sapFlowProcessNodeQuery.isLoading;
  return (
    <Dialog
      show={props.show}
      title={<Typography.h3>Process Node Status History</Typography.h3>}
      onClose={props.handleClose}
      style={{ display: 'flex', flexDirection: 'column', width: '1200px', height: '800px', maxHeight: '80%' }}
    >
      {loading && <Loader></Loader>}
      {!loading && sapFlowProcessNodeQuery.data && (
        <div style={{ paddingTop: '4rem' }}>
          <Typography.h1 fontWeight="light" textAlign="center">
            {sapFlowProcessNodeQuery.data.displayname}
          </Typography.h1>
          <div>
            <Logs statusHistory={sapFlowProcessNodeQuery.data.processNodeStatusHistory}></Logs>
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default SapFlowStatusHistory;
